// extracted by mini-css-extract-plugin
export default {"nodataFound":"CommonInfiniteScroll_nodataFound__yTFY3","nodatatext":"CommonInfiniteScroll_nodatatext__4P2Q+"};